/**
 * Extract YYYY-MM-DD from ISO string or return as-is if already short.
 */
export function toYYYYMMDD(val) {
  if (!val) return null;
  const s = String(val);
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : s;
}

/**
 * Get local date in YYYY-MM-DD format (timezone-safe for UI validations).
 */
export function getLocalISODate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** Local calendar date as DD/MM/YYYY (always day first; avoids locale engine ordering). */
export function formatLocalDMYSlashed(date) {
  if (!date || Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

/** Parse YYYY-MM-DD to local Date at midnight (for minDate on pickers). */
export function parseLocalYmdToDate(ymd) {
  if (!ymd) return null;
  const s = String(ymd);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

export function startOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
/** Format a date with the active application language. */
export function formatLocalizedDate(value, options = { day: "numeric", month: "long", year: "numeric" }, languageOverride) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const language = languageOverride || (typeof document !== "undefined" && document.documentElement.lang) || "ge";
  let locale = "en-GB";
  if (language === "ge" || language.startsWith("ka")) {
    locale = "ka-GE";
  } else if (language === "ru") {
    locale = "ru-RU";
  }
  const formatter = new Intl.DateTimeFormat(locale, options);
  if (locale === "ka-GE" && !options.dateStyle && !options.timeStyle) {
    return formatter
      .formatToParts(date)
      .filter((part) => part.type !== "literal")
      .map((part) => part.value)
      .join(" ");
  }
  return formatter.format(date);
}
